import { useEffect, useState } from "react";
import {
    Container,
    Row,
    Col
} from "reactstrap";

import { RiBook2Line } from "react-icons/ri";

import Api from "../../components/helpers/Api";
import { SeoHelper } from "../../components/helpers/SeoHelper";
import { Link } from "react-router-dom";
import { formatThemeSlug } from "./ThemeSongsPage";

export default function ThemeSongsIndex() {

    const [themes, setThemes] = useState([]);

    useEffect(() => {
        Api.get("/api/themes")
            .then(res => setThemes(res.data || []))
            .catch(err => console.error("Failed to load themes", err));
    }, []);

    useEffect(() => {
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'view_song_list', {
                content_type: 'theme_index',
                source: 'browse'
            });
        }
    }, []);

    // clear session
    sessionStorage.removeItem("selected-themes");

    return (
        <>
            {/* ✅ DETERMINISTIC SEO */}
            <SeoHelper
                uri="/themes"
                title="Worship Songs by Biblical Themes"
                description="Discover worship songs connected with Biblical themes. Find songs for righteousness, freedom, and other themes to help plan meaningful church services."
            />

            <section className="section section-lg">

                <Container>

                    <Row className="justify-content-center">

                        <Col lg="8">

                            <h1 className="display-3 text-center text-primary">
                                Worship Songs for Biblical Themes
                            </h1>

                            <p className="lead text-center text-muted mb-5">
                                Explore worship songs connected with specific Biblical themes
                                to help plan meaningful church services rooted in scripture.
                            </p>

                            <h2 className="h4 text-center mb-4">
                                Browse Songs by Theme
                            </h2>

                            <ul className="twb-next-steps">

                                {themes.map(theme => (
                                    <li key={theme.id}>
                                        <Link
                                            to={`/themes/${theme.id}/${formatThemeSlug(theme.title)}`}
                                            className="twb-next-step"
                                        >
                                            <div className="twb-next-step-icon">
                                                <RiBook2Line size={24}/>
                                            </div>

                                            <div className="twb-next-step-text">
                                                Songs for {theme.title}
                                            </div>
                                        </Link>
                                    </li>
                                ))}

                            </ul>

                            <p className="text-muted mt-5">
                                Many churches plan worship services around scripture readings.
                                These pages help you discover worship songs connected to specific
                                Biblical themes such as grace, redemption, and faith.
                            </p>

                            <p className="text-center text-muted mt-4">
                                Select a theme to discover songs that connect with its message.
                            </p>

                        </Col>

                    </Row>

                </Container>

            </section>
        </>
    );
}
